import React from "react"
import styled from "styled-components"

const PullQuote = styled.q`
  & {
    display: block;
    font-size: var(--font-xl);
    color: var(--color-text-inactive);
    margin: var(--spacing-xl) var(--spacing-xl);
    line-height: 1.4;
  }

  &:before,
  &:after {
    content: none;
  }
`

const BlockPullQuote = ({ data }) => {
  return <PullQuote>{data.quoteBody}</PullQuote>
}

export default BlockPullQuote
